import { api, call } from "./client.js";

/**
 * Auth API client. Each function returns the unwrapped `data` payload so
 * components and react-query hooks don't have to dig through the envelope.
 */

export async function login({ email, password }) {
  // skipAuth so we don't accidentally send a stale token from a previous session.
  const response = await api.post("/auth/login", { email, password }, { skipAuth: true });
  return response.data?.data; // { user, accessToken }
}

export function logout() {
  return call("post", "/auth/logout");
}

export function getMe() {
  return call("get", "/auth/me"); // { user }
}

export function changePassword({ currentPassword, newPassword }) {
  return call("patch", "/auth/change-password", {
    data: { currentPassword, newPassword },
  });
}

export async function forgotPassword({ email }) {
  await api.post("/auth/forgot-password", { email }, { skipAuth: true });
}

export async function resetPassword({ token, password }) {
  await api.post("/auth/reset-password", { token, password }, { skipAuth: true });
}
